<app-auth-drawer heading="forgot password" description="forgot password description" (closed)="close()">
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" novalidate class="flex flex-col gap-5!">
    <div class="flex flex-col gap-2!">
      <label for="fp-email" class="auth-label">{{ 'email' | translate }} <span aria-hidden="true" class="auth-required">*</span></label>
      <input id="fp-email"
             type="email"
             autocomplete="email"
             formControlName="email"
             cdkFocusInitial
             class="auth-input"
             [class.auth-input-invalid]="isInvalid('email')"
             [attr.aria-invalid]="isInvalid('email')"
             [placeholder]="'enter your email address' | translate"/>
      @if (isInvalid('email')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>
          @if (hasError('email', 'required')) {
            {{ 'email required' | translate }}
          } @else if (hasError('email', 'pattern')) {
            {{ 'email invalid' | translate }}
          } @else {
            {{ 'email does not exist' | translate }}
          }
        </p>
      }
    </div>

    <div class="flex flex-col gap-2!">
      <label for="fp-code" class="auth-label">{{ 'security code' | translate }} <span aria-hidden="true" class="auth-required">*</span></label>
      <div class="flex gap-2.5! items-stretch">
        <div aria-live="polite" class="auth-security-code">{{ securityCode }}</div>
        <button type="button"
                class="auth-security-code-refresh"
                [attr.aria-label]="'get a new code' | translate"
                (click)="refreshSecurityCode()">
          <i-tabler name="refresh" class="icon-18 d-flex" />
        </button>
        <input id="fp-code"
               type="text"
               inputmode="numeric"
               maxlength="5"
               autocomplete="off"
               formControlName="securityCode"
               class="auth-input flex-1 min-w-0"
               [class.auth-input-invalid]="isInvalid('securityCode')"
               [attr.aria-invalid]="isInvalid('securityCode')"
               [placeholder]="'enter the code' | translate"/>
      </div>
      @if (isInvalid('securityCode')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>{{ (hasError('securityCode', 'required') ? 'security code required' : 'security code invalid') | translate }}</p>
      }
    </div>

    <div class="flex flex-col gap-3! pt-1!">
      <button type="submit" class="auth-btn auth-btn-primary" [disabled]="spinLoader" [attr.aria-busy]="spinLoader">
        @if (spinLoader) {
          <span class="loading-container"><mat-icon>hourglass_empty</mat-icon></span>
        }
        {{ 'send link' | translate }}
      </button>
      <button type="button" class="auth-btn auth-btn-secondary" (click)="close()">{{ 'cancel' | translate }}</button>
    </div>
  </form>
</app-auth-drawer>
